<template>
  <i :class="_class"></i>
</template>

<script>
export default {
  name: 'JwChat-icon',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    _class () {
      // console.log('index class = ', this.$style.iconfont);
      // console.log('index tyle = ', this.$style[this.type]);

      return {
        [this.$style.iconfont]: true,
        [this.$style[this.type]]: true
      }
    }
  }
}
</script>

<style module>
@font-face {font-family: "iconfont";
  src: url('./fonts/iconfont.eot'); /* IE9 */
  src: url('./fonts/iconfont.eot') format('embedded-opentype'), /* IE6-IE8 */
  url('data:application/x-font-woff2;charset=utf-8;base64,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') format('woff2'),
  url('./fonts/iconfont.woff') format('woff'),
  url('./fonts/iconfont.ttf') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
  url('./fonts/iconfont.svg') format('svg'); /* iOS 4.1- */
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-look:before {
  content: "\e603";
}

.icon-zyj_unlooked:before {
  content: "\e6e9";
}

.icon-empty:before {
  content: "\e699";
}

.icon-empty1:before {
  content: "\e604";
}

.icon-gengduo:before {
  content: "\e60a";
}

.icon-all:before {
  content: "\e6ef";
}

.icon-QRcode1:before {
  content: "\e75e";
}

.icon-comments:before {
  content: "\e7b2";
}

.icon-comment-single:before {
  content: "\e601";
}

.icon-email:before {
  content: "\e602";
}

.icon-ditu:before {
  content: "\e635";
}

.icon-lishi:before {
  content: "\e64e";
}

.icon-zhangdan:before {
  content: "\e65a";
}

.icon-xiangce:before {
  content: "\e65b";
  color: #444444;
}

.icon-hongbao:before {
  content: "\e623";
}

.icon-shipin:before {
  content: "\e64f";
}

.icon-translate:before {
  content: "\e902";
  background-color: blue;
}

.icon-dizhi:before {
  content: "\e658";
}

.icon-wenjian:before {
  content: "\e73e";
  color: #444444;
}

.icon-xiaolian:before {
  content: "\edb8";
  color: #444444;
}

.icon-Dollar:before {
  content: "\e77d";
  background: red;
}
</style>